import { HttpParams } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { EnquiryService, ResponseStatus, StorageKeys, UserTypes } from "@core";
import { TranslateService } from "@ngx-translate/core";
import { pageRoutes } from "src/app/core/config/page-routes.config";
import {  TicketCategories, TicketCategoryList} from "src/app/core/config/ticket-category.config";

@Component({
    selector: "app-ticket-category",
    templateUrl: "./ticket-category.component.html",
    styleUrls: ["./ticket-category.component.less"],
    standalone: false
})
export class TicketCategoryComponent implements OnInit {
  userTickets: any[] = [];
  faqQuestions: any[] = [];
  faqAnswer: any[] = [];
  question!: string;
  ticketCategories: any[] = [];
  loading: boolean = false;
  disableField: boolean = true;
  ticketCategoryVisibility: boolean = false;
  resultNotFound: boolean = false;
  searchForm!: FormGroup;
  userTypes = UserTypes;
  ticketTypes = TicketCategories;
  ticketCategory!: string;
  userType: any;
  selectedCategory: string = '';
  pageRoutes = pageRoutes;

  constructor(
    private enquiryService: EnquiryService,
    fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService
  ) {
    this.searchForm = fb.group({
      search: [""],
      name: [""],
    });
  }

  get search() {
    return this.searchForm.controls['search'].value;
  }

  ngOnInit(): void {
    this.getUserType();
    this.getTicketCategory();
    this.onCheckIfParamExists();
  }

  onCheckIfParamExists() {
    const complaint = this.route.snapshot.params.complaint;
    if (complaint && TicketCategoryList.includes(complaint.toLowerCase())) {
      this.ticketCategory = complaint;
      this.ticketCategoryVisibility = true;
      return;
    }
    this.router.navigate([pageRoutes.enquiry.openTicket]);
  }

  getUserType() {
    this.userType = JSON.parse(localStorage.getItem(StorageKeys.TOKEN)!);
    this.userType = this.userType?.type;
  }

  openModal() {
    this.ticketCategoryVisibility = true;
  }

  closeModal() {    
    this.ticketCategoryVisibility = false;
    this.router.navigate([pageRoutes.enquiry.openTicket]);
  }

  getTicketCategory() {
    this.enquiryService
      .listFaqCategories()
      .then((res: any) => {
        if (res?.status === "OK") {
          let data = res?.data?.data.map((data: any) => {
            return { onPanelfocus: false, ...data };
          });
          this.ticketCategories = data;
          this.enquiryService.initiateFaqCategory(data);
        }
      })
      .catch((err: any) => {
        console.error(err?.error.message);
      });
  }

  getFaqs(queryParam?: any) {
    this.enquiryService
      .listFaqs(queryParam)
      .then((res: any) => {
        if (res?.status === ResponseStatus.OK) {
          this.faqQuestions = res?.data?.data.map((res: any) => {
            return { ...res, active: false };
          });

          if (!this.faqQuestions.length) {
            this.resultNotFound = true;
          } else {
            this.resultNotFound = false;
          }
        }
      })
      .catch((err: any) => {
        console.error(err?.error?.message);
      });
  }

  onSelectCategory(category: any) {
    this.faqQuestions = [];
    this.faqAnswer = [];
    this.disableField = false;
    this.resultNotFound = false;
    this.searchForm.patchValue({ name: category.name, search: "" });
    this.selectedCategory = category.name

    this.ticketCategories.forEach((e: any) => {
      if (category.name === e.name) {
        e.onPanelfocus = true;
        return;
      }
      e.onPanelfocus = false;
    });
  }

  onSearchTitle(input: any) {
    let value = input.srcElement.value;
    if (value !== "") {
      const queryString = new HttpParams({
        fromObject: this.searchForm.value,
      }).toString();
      let queryParam = `?${queryString}`;
      this.searchForm.patchValue({ search: value });

      setTimeout(() => {
        this.enquiryService.initiateFaqStore({
          ...this.searchForm.value,
          question: this.question,
        });
        this.getFaqs(queryParam);
      }, 1500);
      return;
    }
  }

  onActivatePanel(value: any) {
    this.faqQuestions.forEach((e: any) => {
      if (value.nzHeader === e.question) {
        e.active = true;
        return;
      }
      e.active = false;
    });
  }

  translateCategory(category: string) {
    return this.translate.instant(`TICKET_CATEGORIES.${category.toUpperCase()}`);
  }
}
